import React from 'react';

import range from 'lodash/range';

import { GenericEntityBlockSkeleton } from '@lumapps/lumx-blocks/components/GenericEntityBlockSkeleton';
import { ListItem, Size } from '@lumapps/lumx/react';

const CLASSNAME = 'folder-block-skeleton';
/**
 * A skeleton representing a FolderBlock
 * Displayed when loading
 */
const FolderBlockSkeleton = () => <GenericEntityBlockSkeleton className={CLASSNAME} hasImage thumbnailSize={Size.xs} />;

/** Skeleton made of 3 list item with `GenericEntityBlockSkeleton` inside. */
const FolderBlockSkeletons = range(3).map((i) => (
    <ListItem key={i}>
        <FolderBlockSkeleton />
    </ListItem>
));

export { FolderBlockSkeleton, FolderBlockSkeletons };
